import React, { useMemo } from "react";
import { ConfigProvider, Dropdown } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { updateMealPlan } from "../../../reducer/bookingReducer";

import { FaChevronDown } from "react-icons/fa";

const MealPlanDropDown = ({ setMealPlanChanged }) => {
  const dispatch = useDispatch();
  const { mealPlan } = useSelector((store) => store.booking);

  const items = useMemo(
    () => [
      {
        label: (
          <div
            className="w-[8rem]   flex justify-center items-center p-3"
            onClick={(e) => {
              setMealPlanChanged(true);
              dispatch(updateMealPlan("EP"));
            }}
          >
            <div className="text-fg-secondary font-body text-[0.875rem] font-[500]">
              EP
            </div>
          </div>
        ),
        key: 1,
      },
      {
        label: (
          <div
            className="w-[8rem] flex justify-center items-center p-3"
            onClick={(e) => {
              setMealPlanChanged(true);
              dispatch(updateMealPlan("CP"));
            }}
          >
            <div className="text-fg-secondary font-body text-[0.875rem] font-[500]">
              CP
            </div>
          </div>
        ),
        key: 2,
      },
      {
        label: (
          <div
            className="w-[8rem] flex justify-center items-center p-3"
            onClick={(e) => {
              setMealPlanChanged(true);
              dispatch(updateMealPlan("MAP"));
            }}
          >
            <div className="text-fg-secondary font-body text-[0.875rem] font-[500]">
              MAP
            </div>
          </div>
        ),
        key: 3,
      },
      {
        label: (
          <div
            className="w-[8rem] flex justify-center items-center p-3"
            onClick={(e) => {
              setMealPlanChanged(true);
              dispatch(updateMealPlan("AP"));
            }}
          >
            <div className="text-fg-secondary font-body text-[0.875rem] font-[500]">
              AP
            </div>
          </div>
        ),
        key: 4,
      },
    ],
    []
  );

  return (
    <ConfigProvider
      theme={{
        token: {
          controlPaddingHorizontal: 0,
        },
        components: {
          Dropdown: {
            paddingBlock: 0,
          },
        },
      }}
    >
      <Dropdown
        menu={{ items }}
        trigger={["click"]}
        arrow={true}
        placement="bottom"
        controlPaddingHorizontal={0}
      >
        <div
          className={` rounded-[8px] flex  justify-between items-center px-[12px]  font-body
      py-[4px] min-w-[6rem] h-[55px]  w-[10%] cursor-pointer   bg-surface-muted`}
        >
          <div
            className="flex flex-col justify-start items-start
      "
          >
            <div className=" font-[600] text-[10px] leading-[15px] tracking-[1px] text-fg-muted uppercase">
              Meal
            </div>
            <div className=" font-[500] text-[14px] leading-[14px]  text-fg">
              {mealPlan}
            </div>
          </div>

          <div className="flex items-end justify-end h-[100%] p-1 ">
            <FaChevronDown className="text-fg text-[16px] mb-[2px]" />
          </div>
        </div>
      </Dropdown>
    </ConfigProvider>
  );
};

export default MealPlanDropDown;
